var _rect, _rect2, _path, _path2, _path3, _circle, _circle2, _circle3, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLockedCard = function SvgLockedCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    transform: "translate(0.5)",
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7002,
    y: 15.7617,
    width: 81.3453,
    height: 61.3218,
    rx: 10.0117,
    transform: "rotate(-4.18152 5.7002 15.7617)",
    fill: "url(#paint0_linear_2708_17730)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.3332 36.6976L40.6565 39.7706C39.3824 40.3657 38.4222 41.9919 38.5253 43.4022L39.2645 53.5121C39.3384 54.5231 40.0975 55.8103 40.9526 56.3501L48.1924 60.978C49.4697 61.8006 51.4542 61.6555 52.5983 60.6559L59.088 55.0242C59.8546 54.3533 60.4194 52.9819 60.3455 51.9709L59.6063 41.861C59.5041 40.4631 58.3167 38.9814 56.9705 38.5904L49.9178 36.5212C49.1988 36.2977 48.0255 36.3835 47.3332 36.6976Z",
    fill: "#43AFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5176 46.8467C52.3917 45.1243 50.8916 43.8286 49.1692 43.9545C47.4467 44.0804 46.151 45.5805 46.277 47.303C46.3792 48.7009 47.3876 49.7941 48.6775 50.1013L48.9175 53.3839C48.9549 53.8957 49.4103 54.289 49.922 54.2516C50.4337 54.2142 50.8271 53.7588 50.7897 53.2471L50.5497 49.9645C51.7811 49.4729 52.6198 48.2446 52.5176 46.8467Z",
    fill: "#26A4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43022 25.7468C6.02704 20.2322 10.1707 15.4349 15.6853 15.0317L76.8439 10.5603C82.3585 10.1571 87.1558 14.3008 87.559 19.8154L87.7415 22.3117L6.61272 28.2431L6.43022 25.7468Z",
    fill: "url(#paint1_linear_2708_17730)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9183,
    cy: 21.3542,
    r: 1.83251,
    transform: "rotate(-4.18152 13.9183 21.3542)",
    fill: "#2FA7FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4017,
    cy: 20.9538,
    r: 1.83251,
    transform: "rotate(-4.18152 19.4017 20.9538)",
    fill: "#2FA7FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8841,
    cy: 20.5524,
    r: 1.83251,
    transform: "rotate(-4.18152 24.8841 20.5524)",
    fill: "#2FA7FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1214,
    cy: 83.667,
    rx: 39.4212,
    ry: 2.50293,
    fill: "#F1F1F1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2708_17730",
    x1: 25.0979,
    y1: -3.01027,
    x2: 47.9229,
    y2: 76.6393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2708_17730",
    x1: 13.0521,
    y1: 13.342,
    x2: 25.5334,
    y2: 39.1019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACDCFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLockedCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "locked-card.b0c05701dcde0b413c349efe70ab89c5.svg";